const FILTER = 'filter';

export default class filterHistory {
    constructor(localStorageService) {
        return {

            saveFilter(filter, key){
                 let filterObj = localStorageService.get(FILTER) || {};
                 filterObj[key] = filter;
                 localStorageService.set(FILTER, filterObj);
            },

            readFilter(key){
                 let filter = localStorageService.get(FILTER) || {};
                 return filter[key];
            },

            removeFilter(key){
                let filter = localStorageService.get(FILTER);                
                delete filter[key];
                localStorageService.set(FILTER, filter);
            }
        };
    }
}

filterHistory.inject = ['localStorageService'];



/** WEBPACK FOOTER **
 ** ./src/app/services/filterHistory.js
 **/